import { useMemo, useState, type ReactNode } from 'react';
import {
  ActiveOrganisationContext,
  useActiveOrganisationState,
} from '@/lib/activeOrganisation.ts';
import { RecordOrganisationContext } from '@/lib/recordOrganisation.ts';

/*
 * Holds the console's organisation for every page under it. Mounted inside the
 * shell rather than around the router: it reads the signed-in user, and above the
 * session guard there is not one yet.
 */
export function ActiveOrganisationProvider({ children }: { children: ReactNode }) {
  const value = useActiveOrganisationState();
  const [recordId, setRecordId] = useState<string | null>(null);
  const record = useMemo(() => ({ id: recordId, setId: setRecordId }), [recordId]);

  return (
    <ActiveOrganisationContext value={value}>
      <RecordOrganisationContext value={record}>{children}</RecordOrganisationContext>
    </ActiveOrganisationContext>
  );
}
